import * as React from "react";
import ContactListGetter from "./ContactsListGetter";
import ContactListRenderer from "./ContactsListRenderer";

export interface ContactListRendererProps {
  loading: boolean;
  contactUsData: Array<any>;
  totalCount: number;
  paginationModel: {
    page: number;
    pageSize: number;
  }
  setPaginationModel: React.Dispatch<React.SetStateAction<{
    page: number;
    pageSize: number;
  }>>;
  setRefreshTable: React.Dispatch<React.SetStateAction<number>>;
}

const ContactsList: React.FC = () => {
  return (
    <ContactListGetter>{({ contactUsData, totalCount, loading, paginationModel, setPaginationModel, setRefreshTable }) => (
      <ContactListRenderer
        contactUsData={contactUsData}
        totalCount={totalCount}
        loading={loading}
        paginationModel={paginationModel}
        setPaginationModel={setPaginationModel}
        setRefreshTable={setRefreshTable}
      />
    )}</ContactListGetter>
  );
};

export default ContactsList;
